const PARENT_SELECTOR = '[data-test="search-result-section"]';

/**
 * Clears the URL-based ownership filter (`hideOwnership` param)
 * and removes the DOM attribute that hides owned assets.
 */
export function clearOwnershipFilter(): void {
  if (typeof window === 'undefined') return;
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('hideOwnership')) {
    currentUrl.searchParams.delete('hideOwnership');
    window.history.pushState({}, '', currentUrl);
    document.querySelector(PARENT_SELECTOR)?.removeAttribute('data-hide-owned');
  }
}
